import { render, staticRenderFns } from "./editBShopModel.vue?vue&type=template&id=63cc1392&scoped=true"
import script from "./editBShopModel.vue?vue&type=script&lang=js"
export * from "./editBShopModel.vue?vue&type=script&lang=js"
import style0 from "./editBShopModel.vue?vue&type=style&index=0&id=63cc1392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc1392",
  null
  
)

export default component.exports